import './App.css';
import './assets/css/style.css'
import Layout from './routing/Layout';
import { BrowserRouter as Router } from "react-router-dom";
import 'bootstrap/dist/css/bootstrap.min.css';
import { Elements } from "@stripe/react-stripe-js";
import { loadStripe } from "@stripe/stripe-js";
import { get_settings_section } from './api/Global';
import { useEffect, useState } from 'react';

function App() {
  const stripePromise = loadStripe("pk_test_51Qvy5kADrzTAtNzIYIEXyE2oAtOaScgMiWoSA3kGQBHHhvb8scFa12K25Rdq6UFMKuICGPk7RWm6eHspGV7sMGLX00Jrdretvq");
  const [get_settings, set_get_settings] = useState({});

  useEffect(() => {
    const handle_get_settings = async () => {
      try {
        const response = await get_settings_section();
        set_get_settings(response?.data?.data?.settings);

        // Call the function to update favicon dynamically
        if (response?.data?.data?.settings?.fav_icon) {
          updateFavicon(response?.data?.data?.settings?.fav_icon);
        }
      } catch (error) {
        console.log("error", error);
      }
    };

    handle_get_settings();
  }, []);

   // Function to update the favicon
   const updateFavicon = (faviconUrl) => {
    let link = document.querySelector("link[rel~='icon']");
    
    if (!link) {
      link = document.createElement("link");
      link.rel = "icon";
      document.head.appendChild(link);
    }
    
    link.href = faviconUrl;
  };

  return (
    <Elements stripe={stripePromise}>
      <Router>
        <Layout />
      </Router>
    </Elements>
  );
}

export default App;
